module.exports = __webpack_public_path__ + "img/vi.3d5ad23b.png";